<template>
  <q-dialog v-model="activate">
    <q-card style="width: 320px">
      <div class="q-pa-md">
        <div class="row q-gutter-sm">
          <div class="col-12 hide-me-on-desktop">
            <q-select
              filled
              label="Select company"
              v-model="companyFilter"
              outlined
              :disable="companies.length === 0 || loading"
              label-color="grey-7"
              color="grey-7"
              :options="companies"
              :option-label="(company) => company.name"
              :option-value="(company) => company.id"
            >
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-italic text-grey">
                    There is no options.
                  </q-item-section>
                </q-item>
              </template>
              <template v-slot:append>
                <q-icon
                  size="15px"
                  style="margin-top: 3px"
                  v-if="!!companyFilter.id"
                  class="cursor-pointer"
                  name="fas fa-times"
                  @click="companyFilter = {}"
                  @click.stop="!companyFilter.id"
                />
              </template>
            </q-select>
          </div>
          <div class="col-12 hide-me-on-desktop">
            <q-select
              filled
              label="Select Location"
              v-model="multiFilter"
              outlined
              :display-value="shorter"
              multiple
              :disable="locations.length === 0 || loading || !companyFilter.id"
              label-color="grey-7"
              color="grey-7"
              :options="locations"
            >
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-italic text-grey">
                    There is no options.
                  </q-item-section>
                </q-item>
              </template>
              <template v-slot:append>
                <q-icon
                  size="15px"
                  style="margin-top: 3px"
                  v-if="!!multiFilter.length > 0"
                  class="cursor-pointer"
                  name="fas fa-times"
                  @click="multiFilter = []"
                  @click.stop="!multiFilter.length === 0"
                />
              </template>
              <template v-slot:option="locations">
                <q-item
                  :disable="loading"
                  @click="locationFilterPusher(locations.opt)"
                  dense
                  clickable
                  v-ripple
                >
                  <q-item-section side top>
                    <q-checkbox
                      size="xs"
                      v-model="multiFilter"
                      :val="locations.opt"
                    />
                  </q-item-section>
                  <q-item-section>{{ locations.opt.code }}</q-item-section>
                </q-item>
              </template>
            </q-select>
          </div>
          <div class="col-12 hide-me-on-desktop">
            <q-select
              filled
              label="Vehicle Condition Assumption"
              outlined
              label-color="grey-7"
              color="grey-7"
              :options="conditions"
              :option-label="(cond) => cond.name"
              v-model="conditionChooser"
            >
            </q-select>
          </div>
          <div class="col-12">
            <q-select
              filled
              label="Tag Filter"
              outlined
              multiple
              :disable="manuals.length === 0"
              :options="manuals"
              :option-label="(m) => m.name"
              :option-value="(m) => m.id"
              v-model="selectedTags"
            >
              <template v-slot:append>
                <q-icon
                  size="15px"
                  style="margin-top: 3px"
                  v-if="selectedTags.length > 0"
                  class="cursor-pointer"
                  name="fas fa-times"
                  @click="selectedTags = []"
                  @click.stop="selectedTags.length === 0"
                />
              </template>
            </q-select>
          </div>
          <div class="col-12">
            <q-select
              filled
              label="Provider Filter"
              outlined
              :options="advancedFilters.providers"
              :option-label="(provider_item) => provider_item.name"
              :option-value="(provider_item) => provider_item.key"
              v-model="provider"
            ></q-select>
          </div>
          <div class="col-12">
            <q-select
              filled
              label="Condition Filter"
              outlined
              multiple
              :options="conditionFilters"
              :option-label="(cond) => cond.name"
              :option-value="(cond) => cond.val"
              v-model="conditionChooserFilter"
            >
              <template v-slot:append>
                <q-icon
                  size="15px"
                  style="margin-top: 3px"
                  v-if="conditionChooserFilter.length > 0"
                  class="cursor-pointer"
                  name="fas fa-times"
                  @click="conditionChooserFilter = []"
                  @click.stop="conditionChooserFilter.length === 0"
                />
              </template>
            </q-select>
          </div>
          <div class="col-12">
            <q-select
              label="Finance"
              filled
              multiple
              :disable="advancedFilters.sources.length === 0 || loading"
              v-model="sources"
              :options="advancedFilters.sources"
            >
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-italic text-grey">
                    There is no options.
                  </q-item-section>
                </q-item>
              </template>
              <template v-slot:append>
                <q-icon
                  size="15px"
                  style="margin-top: 3px"
                  v-if="!!sources.length > 0"
                  class="cursor-pointer"
                  name="fas fa-times"
                  @click="sources = []"
                  @click.stop="!sources.length === 0"
                />
              </template>
              <template #before-options>
                <q-item
                  dense
                  clickable
                  tag="label"
                  @click="selectAllByType('sources')"
                  v-ripple
                >
                  <q-item-section side>
                    <span
                      class="virtual-checkbox"
                      :class="
                        sources.length === advancedFilters.sources.length
                          ? 'virtual-checkbox-checked'
                          : ''
                      "
                    >
                      <i
                        v-if="sources.length === advancedFilters.sources.length"
                        class="fas fa-check"
                      ></i>
                    </span>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>Select All</q-item-label>
                  </q-item-section>
                </q-item>
              </template>
              <template v-slot:option="markSources">
                <q-item
                  :disable="loading"
                  tag="label"
                  @click="sourceManagement(markSources.opt)"
                  dense
                  clickable
                  v-ripple
                >
                  <q-item-section side top>
                    <span
                      class="virtual-checkbox"
                      style="margin-top: 4px"
                      :class="
                        sources.includes(markSources.opt)
                          ? 'virtual-checkbox-checked'
                          : ''
                      "
                    >
                      <i
                        v-if="sources.includes(markSources.opt)"
                        class="fas fa-check"
                      ></i>
                    </span>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>{{ markSources.opt }}</q-item-label>
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
          </div>
          <div class="col-12">
            <q-select
              filled
              label="Estimated Revenue/Loss"
              :options="advancedFilters.sign"
              :option-label="(sign) => sign.name"
              :option-value="(sign) => sign.value"
              v-model="signs"
            >
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-italic text-grey">
                    There is no options.
                  </q-item-section>
                </q-item>
              </template>
              <template v-slot:append>
                <q-icon
                  size="15px"
                  style="margin-top: 3px"
                  v-if="!!signs"
                  class="cursor-pointer"
                  name="fas fa-times"
                  @click="signs = ''"
                  @click.stop="!signs"
                />
              </template>
            </q-select>
          </div>
          <div class="col-12">
            <q-select
              label="Groups"
              filled
              multiple
              :disable="advancedFilters.groups.length === 0 || loading"
              v-model="groups"
              :options="advancedFilters.groups"
            >
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-italic text-grey">
                    There is no options.
                  </q-item-section>
                </q-item>
              </template>
              <template v-slot:append>
                <q-icon
                  size="15px"
                  style="margin-top: 3px"
                  v-if="!!groups.length > 0"
                  class="cursor-pointer"
                  name="fas fa-times"
                  @click="groups = []"
                  @click.stop="!groups.length === 0"
                />
              </template>
              <template #before-options>
                <q-item
                  dense
                  clickable
                  tag="label"
                  @click="selectAllByType('groups')"
                  v-ripple
                >
                  <q-item-section side>
                    <span
                      class="virtual-checkbox"
                      :class="
                        groups.length === advancedFilters.groups.length
                          ? 'virtual-checkbox-checked'
                          : ''
                      "
                    >
                      <i
                        v-if="groups.length === advancedFilters.groups.length"
                        class="fas fa-check"
                      ></i>
                    </span>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>Select All</q-item-label>
                  </q-item-section>
                </q-item>
              </template>
              <template v-slot:option="markGroups">
                <q-item
                  :disable="loading"
                  tag="label"
                  @click="groupManagement(markGroups.opt)"
                  dense
                  clickable
                  v-ripple
                >
                  <q-item-section side top>
                    <span
                      class="virtual-checkbox"
                      style="margin-top: 4px"
                      :class="
                        groups.includes(markGroups.opt)
                          ? 'virtual-checkbox-checked'
                          : ''
                      "
                    >
                      <i
                        v-if="groups.includes(markGroups.opt)"
                        class="fas fa-check"
                      ></i>
                    </span>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>{{ markGroups.opt }}</q-item-label>
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
          </div>
          <div class="col-12">
            <q-select
              label="Model Years"
              filled
              multiple
              :disable="advancedFilters.model_years.length === 0 || loading"
              v-model="modelYears"
              :options="advancedFilters.model_years"
            >
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-italic text-grey">
                    There is no options.
                  </q-item-section>
                </q-item>
              </template>
              <template v-slot:append>
                <q-icon
                  size="15px"
                  style="margin-top: 3px"
                  v-if="!!modelYears.length > 0"
                  class="cursor-pointer"
                  name="fas fa-times"
                  @click="modelYears = []"
                  @click.stop="!modelYears.length === 0"
                />
              </template>
              <template #before-options>
                <q-item
                  dense
                  clickable
                  tag="label"
                  @click="selectAllByType('modelYears')"
                  v-ripple
                >
                  <q-item-section side>
                    <span
                      class="virtual-checkbox"
                      :class="
                        modelYears.length === advancedFilters.model_years.length
                          ? 'virtual-checkbox-checked'
                          : ''
                      "
                    >
                      <i
                        v-if="
                          modelYears.length ===
                            advancedFilters.model_years.length
                        "
                        class="fas fa-check"
                      ></i>
                    </span>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>Select All</q-item-label>
                  </q-item-section>
                </q-item>
              </template>
              <template v-slot:option="markModelYears">
                <q-item
                  :disable="loading"
                  tag="label"
                  @click="modelYearsManagement(markModelYears.opt)"
                  dense
                  clickable
                  v-ripple
                >
                  <q-item-section side top>
                    <span
                      class="virtual-checkbox"
                      style="margin-top: 4px"
                      :class="
                        modelYears.includes(markModelYears.opt)
                          ? 'virtual-checkbox-checked'
                          : ''
                      "
                    >
                      <i
                        v-if="modelYears.includes(markModelYears.opt)"
                        class="fas fa-check"
                      ></i>
                    </span>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>{{ markModelYears.opt }}</q-item-label>
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
          </div>
          <!-- <div class="col-12">
            <q-select
              :disable="!signs.value || loading"
              label="Revenue Range"
              filled
              :options="rangeDefiner"
              :option-label="range => range.name"
              :option-value="range => range.val"
              v-model="rangeVal"
            >
              <template v-slot:append>
                <q-icon
                  size="15px"
                  style="margin-top:3px"
                  v-if="!!rangeVal"
                  class="cursor-pointer"
                  name="fas fa-times"
                  @click="rangeVal = ''"
                  @click.stop="!rangeVal"
                />
              </template>
            </q-select>
          </div>-->
          <div class="col-12">
            <q-field
              style="cursor: pointer"
              :disable="advancedFilters.brands.length === 0 || loading"
              label="Brands"
              :stack-label="brands.length > 0 ? true : false"
              filled
            >
              <template #default>
                <q-menu square fit max-height="350px">
                  <div
                    class="brand-container"
                    @click="selectAllByType('brands')"
                  >
                    <div class="brand-inner">
                      <div
                        class="brand-checkbox virtual-checkbox"
                        style="margin-top: 4px"
                        :class="
                          brands.length === advancedFilters.brands.length
                            ? 'virtual-checkbox-checked'
                            : ''
                        "
                      >
                        <i
                          v-if="brands.length === advancedFilters.brands.length"
                          class="fas fa-check"
                        ></i>
                      </div>
                      <div class="brand-name">Select All</div>
                    </div>
                  </div>
                  <div
                    class="brand-container"
                    v-for="(brand, index) in advancedFilters.brands"
                    :key="brand.id"
                  >
                    <div class="brand-inner">
                      <div
                        @click="brandManagement(brand)"
                        class="brand-checkbox virtual-checkbox"
                        style="margin-top: 4px"
                        :class="
                          brands.some((item) => brand.id === item.id)
                            ? 'virtual-checkbox-checked'
                            : ''
                        "
                      >
                        <i class="fas fa-check"></i>
                      </div>
                      <div class="brand-name" @click="brandManagement(brand)">
                        {{ brand.name }}
                      </div>
                      <div class="brand-arrow" @click="expandManagement(index)">
                        <i class="fas fa-chevron-down"></i>
                      </div>
                    </div>
                    <transition-group name="component-fade" tag="div">
                      <div
                        v-if="clickedIndex === index"
                        class="brand-inner models"
                        v-for="(model, i) in brand.models"
                        :key="model.id"
                        @click="modelManagement(brand, model, i)"
                      >
                        <div
                          :class="
                            brands.some((item) =>
                              item.models.some((j) => j.id === model.id)
                            )
                              ? 'virtual-checkbox-checked'
                              : ''
                          "
                          class="brand-checkbox virtual-checkbox"
                          style="margin-top: 4px"
                        >
                          <i class="fas fa-check"></i>
                        </div>
                        <div class="brand-name">{{ model.name }}</div>
                      </div>
                    </transition-group>
                  </div>
                </q-menu>
              </template>

              <template #control>
                <div class="brand-controller">
                  <div
                    class="brand-controller-name"
                    v-for="(item, index) in brandNames"
                    :key="index"
                  >
                    {{ item }}
                  </div>
                </div>
              </template>
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-italic text-grey">
                    There is no options.
                  </q-item-section>
                </q-item>
              </template>
              <template v-slot:append>
                <i
                  class="fas fa-times clearable"
                  v-if="brands.length > 0"
                  @click="brands = []"
                ></i>
                <i class="fas fa-caret-down" style="margin-right: 5px"></i>
              </template>
            </q-field>
          </div>
          <div class="col-12">
            <q-select
              label="Class"
              filled
              multiple
              :disable="advancedFilters.classes.length === 0 || loading"
              v-model="classes"
              :options="advancedFilters.classes"
            >
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-italic text-grey">
                    There is no options.
                  </q-item-section>
                </q-item>
              </template>
              <template v-slot:append>
                <q-icon
                  size="15px"
                  style="margin-top: 3px"
                  v-if="!!classes.length > 0"
                  class="cursor-pointer"
                  name="fas fa-times"
                  @click="classes = []"
                  @click.stop="!classes.length === 0"
                />
              </template>
              <template #before-options>
                <q-item
                  dense
                  clickable
                  tag="label"
                  @click="selectAllByType('classes')"
                  v-ripple
                >
                  <q-item-section side>
                    <span
                      class="virtual-checkbox"
                      :class="
                        classes.length === advancedFilters.classes.length
                          ? 'virtual-checkbox-checked'
                          : ''
                      "
                    >
                      <i
                        v-if="classes.length === advancedFilters.classes.length"
                        class="fas fa-check"
                      ></i>
                    </span>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>Select All</q-item-label>
                  </q-item-section>
                </q-item>
              </template>
              <template v-slot:option="markClasses">
                <q-item
                  :disable="loading"
                  tag="label"
                  @click="classesManagement(markClasses.opt)"
                  dense
                  clickable
                  v-ripple
                >
                  <q-item-section side top>
                    <span
                      class="virtual-checkbox"
                      style="margin-top: 4px"
                      :class="
                        classes.includes(markClasses.opt)
                          ? 'virtual-checkbox-checked'
                          : ''
                      "
                    >
                      <i
                        v-if="classes.includes(markClasses.opt)"
                        class="fas fa-check"
                      ></i>
                    </span>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>{{ markClasses.opt }}</q-item-label>
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
          </div>
          <div class="col-12">
            <q-btn @click="reset" style="margin-right: 5px" color="secondary"
              >RESET</q-btn
            >
            <q-btn :disable="loading" color="primary" @click="getParams"
              >APPLY</q-btn
            >
          </div>
        </div>
      </div>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  data() {
    return {
      clickedIndex: "",
      isExpand: false,
      expandItem: {},
      sources: this.$store.state.profit.source || [], // done
      groups: this.$store.state.profit.group || [], // done
      classes: this.$store.state.profit.class || [],
      brands: this.$store.state.profit.brandId || [],
      modelYears: this.$store.state.profit.modelYear || [], // done
      signs: this.$store.state.profit.sign || "", // done
      models: this.$store.state.profit.modelId || [],
      rangeVal: this.$store.state.profit.range || "",
    };
  },
  computed: {
    provider: {
      get() {
        return this.$store.state.profit.provider;
      },
      set(val) {
        this.$store.commit("profit/SET_PROVIDER", val);
      },
    },
    manuals() {
      return this.$store.state.tag.tags;
    },
    selectedTags: {
      get() {
        return this.$store.state.profit.selectedTags;
      },
      set(val) {
        this.$store.commit("profit/SET_TAG_CONDITION", val);
      },
    },
    conditionFilters() {
      return this.$store.state.profit.conditionFilters;
    },
    conditionChooserFilter: {
      get() {
        return this.$store.state.profit.conditionChooserFilter;
      },
      set(val) {
        this.$store.commit("profit/SET_FILTER_CONDITION", val);
      },
    },
    conditions() {
      return this.$store.state.profit.conditions;
    },
    conditionChooser: {
      get() {
        return this.$store.state.profit.conditionChooser;
      },
      set(val) {
        this.$store.commit("profit/SET_CONDITION_SETTER", val);
      },
    },
    brandNames() {
      var names = this.brands.map((item, index) =>
        index !== 0 ? `,${item.name}` : `${item.name}`
      );

      return names || [];
    },
    companyFilter: {
      get() {
        return this.$store.state.profit.companyFilter;
      },
      set(val) {
        this.$store.commit("profit/SET_COMPANY_FILTER", val);
      },
    },
    companies: {
      get() {
        return this.$store.state.profit.companies;
      },
      set(val) {
        this.$store.commit("profit/SET_COMPANIES", val);
      },
    },
    locations: {
      get() {
        return this.$store.state.profit.locations;
      },
      set(val) {
        this.$store.commit("profit/SET_LOCATIONS", val);
      },
    },
    shorter() {
      if (this.multiFilter.length > 0 && this.multiFilter.length < 2) {
        return this.multiFilter[0].code;
      } else if (this.multiFilter.length > 1) {
        return `${this.multiFilter[0].code} +${this.multiFilter.length - 1}`;
      }
    },
    multiFilter: {
      get() {
        return this.$store.state.profit.multiFilter;
      },
      set(val) {
        this.$store.commit("profit/SET_MULTI_FILTER", val);
      },
    },
    rangeDefiner() {
      if (this.signs.value === "positive") {
        return this.advancedFilters.positive;
      } else if (this.signs.value === "negative") {
        return this.advancedFilters.negative;
      }
    },
    loading() {
      return this.$store.state.profit.loading;
    },
    advancedFilters: {
      get() {
        return this.$store.state.profit.advancedFilters;
      },
      set(val) {
        this.$store.commit("profit/SET_ADVANCED_FILTER", val);
      },
    },
    activate: {
      get() {
        return this.$store.state.profit.activate;
      },
      set(val) {
        this.$store.commit("profit/SET_ACTIVATE_MODAL", val);
      },
    },
    markSources() {
      return this.advancedFilters.sources;
    },
    markGroups() {
      return this.advancedFilters.groups;
    },
    markModelYears() {
      return this.advancedFilters.modelYears;
    },
    source: {
      get() {
        return this.$store.state.profit.source;
      },
      set(val) {
        this.$store.commit("profit/SET_SOURCES", val);
      },
    },
    group: {
      get() {
        return this.$store.state.profit.group;
      },
      set(val) {
        this.$store.commit("profit/SET_GROUPS", val);
      },
    },
    class: {
      get() {
        return this.$store.state.profit.class;
      },
      set(val) {
        this.$store.commit("profit/SET_CLASSES", val);
      },
    },
    brandId: {
      get() {
        return this.$store.state.profit.brandId;
      },
      set(val) {
        this.$store.commit("profit/SET_BRANDS_ID", val);
      },
    },
    modelYear: {
      get() {
        return this.$store.state.profit.modelYear;
      },
      set(val) {
        this.$store.commit("profit/SET_MODEL_YEARS", val);
      },
    },
    sign: {
      get() {
        return this.$store.state.profit.sign;
      },
      set(val) {
        this.$store.commit("profit/SET_SIGN", val);
      },
    },
    min: {
      get() {
        return this.$store.state.profit.min;
      },
      set(val) {
        this.$store.commit("profit/SET_MIN", val);
      },
    },
    max: {
      get() {
        return this.$store.state.profit.max;
      },
      set(val) {
        this.$store.commit("profit/SET_MAX", val);
      },
    },
    modelId: {
      get() {
        return this.$store.state.profit.modelId;
      },
      set(val) {
        this.$store.commit("profit/SET_MODELS_ID", val);
      },
    },
    range: {
      get() {
        return this.$store.state.profit.range;
      },
      set(val) {
        this.$store.commit("profit/SET_RANGE_VAL", val);
      },
    },
    requestParams() {
      const params = {
        locations: this.$store.state.profit.multiFilter,
        company: this.$store.state.profit.companyFilter,
      };
      return params;
    },
  },
  methods: {
    expandManagement(index) {
      this.clickedIndex === index
        ? (this.clickedIndex = "")
        : (this.clickedIndex = index);
    },
    locationFilterPusher(location) {
      if (this.multiFilter.some((item) => item.id === location.id)) {
        const index = this.multiFilter
          .map((item) => item.id)
          .indexOf(location.id);
        if (index !== -1) {
          this.$store.commit("profit/REMOVE_MULTI_FILTER", index);
        }
      } else {
        this.multiFilter = [...this.multiFilter, location];
      }
    },
    deActiveReset() {
      this.source = [];
      this.group = [];
      this.class = [];
      this.brandId = [];
      this.modelYear = [];
      this.modelId = [];
      this.sign = "";
      this.range = "";
      this.sources = [];
      this.groups = [];
      this.classes = [];
      this.provider = { name: "Manheim", key: "manheim" };
      this.brands = [];
      this.modelYears = [];
      this.models = [];
      this.signs = "";
      this.min = "";
      this.rangeVal = "";
      this.max = "";
      this.conditionChooserFilter = [];
    },
    reset() {
      this.deActiveReset();
      this.getParams();
    },
    getParams() {
      this.$emit("getParams", true);
      this.activate = false;
    },
    sourceManagement(val) {
      const isInclude = this.sources.includes(val);
      const index = this.sources.indexOf(val);
      const deep = [...this.sources];
      if (isInclude && index !== -1) {
        deep.splice(index, 1);
        this.sources = deep;
      } else this.sources = [...this.sources, val];
    },

    groupManagement(val) {
      const isInclude = this.groups.includes(val);
      const index = this.groups.indexOf(val);
      const deep = [...this.groups];
      if (isInclude && index !== -1) {
        deep.splice(index, 1);
        this.groups = deep;
      } else this.groups = [...this.groups, val];
    },
    modelYearsManagement(val) {
      const isInclude = this.modelYears.includes(val);
      const index = this.modelYears.indexOf(val);
      const deep = [...this.modelYears];
      if (isInclude && index !== -1) {
        deep.splice(index, 1);
        this.modelYears = deep;
      } else this.modelYears = [...this.modelYears, val];
    },
    classesManagement(val) {
      const isInclude = this.classes.includes(val);
      const index = this.classes.indexOf(val);
      const deep = [...this.classes];
      if (isInclude && index !== -1) {
        deep.splice(index, 1);
        this.classes = deep;
      } else this.classes = [...this.classes, val];
    },
    selectAllByType(type) {
      if (type === "sources") {
        const length = this.sources.length;
        length === this.advancedFilters.sources.length
          ? (this.sources = [])
          : (this.sources = this.advancedFilters.sources);
      } else if (type === "groups") {
        const length = this.groups.length;
        length === this.advancedFilters.groups.length
          ? (this.groups = [])
          : (this.groups = this.advancedFilters.groups);
      } else if (type === "modelYears") {
        const length = this.modelYears.length;
        length === this.advancedFilters.model_years.length
          ? (this.modelYears = [])
          : (this.modelYears = this.advancedFilters.model_years);
      } else if (type === "classes") {
        const length = this.classes.length;
        length === this.advancedFilters.classes.length
          ? (this.classes = [])
          : (this.classes = this.advancedFilters.classes);
      } else if (type === "brands") {
        const length = this.brands.length;
        if (length === this.advancedFilters.brands.length) {
          this.brands = [];
          this.models = [];
        } else {
          this.brands = this.advancedFilters.brands;
        }
      }
    },
    brandManagement(val) {
      const index = this.brands.map((item) => item.id).indexOf(val.id);
      const deep = [...this.brands];
      var deepModels = [];
      if (index !== -1) {
        deep.splice(index, 1);
        for (let i = 0; i < deep.length; i++) {
          for (let j = 0; j < deep[i].models.length; j++) {
            deepModels = [...deepModels, deep[i].models[j]];
          }
        }
        this.brands = deep;
      } else {
        this.brands = [...this.brands, val];
      }
    },
    modelManagement(brand, val, modelIndex) {
      const deep = [...this.brands];
      const haveBrand = this.brands.map((item) => item.id).indexOf(brand.id);
      if (haveBrand !== -1) {
        const brandIndex = this.brands.map((item) => item.id).indexOf(brand.id);
        const modelIndex = this.brands[brandIndex].models
          .map((item) => item.id)
          .indexOf(val.id);
        if (modelIndex !== -1) {
          // todo remove item from array of object inside array item(s)
          var newModels = {
            ...deep[haveBrand],
            models: deep[haveBrand].models.filter((item) => item.id !== val.id),
          };
          newModels.models.length === 0
            ? deep.splice(haveBrand, 1)
            : deep.splice(haveBrand, 1, newModels);
          this.brands = deep;
        } else {
          const [first] = deep[haveBrand].models;
          var models = [first, val];
          var newModel = {
            ...deep[haveBrand],
            models,
          };
          deep.splice(haveBrand, 1, newModel);
          this.brands = deep;
        }
      } else {
        const obj = {
          name: brand.name,
          id: brand.id,
          models: [{ ...val }],
        };
        this.brands = [...this.brands, obj];
      }
    },
  },
  watch: {
    selectedTags: {
      deep: true,
      handler(n, o) {
        this.deActiveReset();
      },
    },
    requestParams: {
      deep: true,
      handler(n, o) {
        this.deActiveReset();
      },
    },
    groups: {
      deep: true,
      handler(n, o) {
        this.group = n;
      },
    },
    sources: {
      deep: true,
      handler(n, o) {
        this.source = n;
      },
    },
    classes: {
      deep: true,
      handler(n, o) {
        this.class = n;
      },
    },
    modelYears: {
      deep: true,
      handler(n, o) {
        this.modelYear = n;
      },
    },
    models: {
      deep: true,
      handler(n, o) {
        this.modelId = n;
      },
    },
    brands: {
      deep: true,
      handler(n, o) {
        this.brandId = n;
      },
    },
    rangeVal(n, o) {
      if (this.signs.value === "positive" && n.val) {
        const [min, max] = n.val.split("-");
        this.min = min;
        this.max = max;
        this.range = n;
      } else if (n.val && this.signs.value === "negative") {
        const [min, max] = n.val.split(",");
        this.min = min;
        this.max = max;
        this.range = n;
      } else {
        this.range = "";
        (this.min = ""), (this.max = "");
      }
    },
    signs(n, o) {
      this.rangeVal = "";
      if (n.value) {
        this.sign = n;
      } else {
        this.sign = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.brand-controller {
  max-width: 380px;
  display: flex;
  flex-flow: row wrap;
  width: 100%;
}
.clearable {
  font-size: 15px;
  margin-top: 3px;
  margin-right: 7px;
  cursor: pointer;
}
.virtual-checkbox {
  width: 20px;
  height: 20px;
  display: flex;
  border: 2px solid #ccc;
  position: relative;
  i {
    position: absolute;
    color: transparent;
    left: 1px;
    top: 1px;
  }
}
.virtual-checkbox-checked {
  border: none;
  background: #027be3;
  i {
    color: #fff;
    left: 3px;
    top: 3px;
  }
}

@media only screen and (min-width: 1024px), (min-device-width: 1024px) {
  .hide-me-on-desktop {
    display: none;
  }
}

.brand-container {
  display: flex;
  flex-flow: column nowrap;
  padding: 5px;
  justify-content: center;
  position: relative;
  cursor: pointer;
  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }
  .brand-inner {
    display: flex;
    flex-flow: row nowrap;
    flex: 1;

    .brand-name {
      margin-top: 4px;
      margin-left: 10px;
      color: #000;
      flex: 1;
    }
    .brand-arrow {
      i {
        font-size: 14px;
        color: #bdbdbd;
        margin-top: 7px;
        margin-right: 5px;
      }
    }
  }
  .models {
    padding-left: 30px;
  }
}
</style>
